'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons';
import * as SelectPrimitive from '@radix-ui/react-select';
import * as React from 'react';
import { cn } from '../../../lib/utils';
const Select = SelectPrimitive.Root;
const SelectGroup = SelectPrimitive.Group;
const SelectValue = SelectPrimitive.Value;
const SelectTrigger = /*#__PURE__*/ React.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ _jsxs(SelectPrimitive.Trigger, {
        ref: ref,
        className: cn('flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1', className),
        ...props,
        children: [
            children,
            /*#__PURE__*/ _jsx(ChevronDownIcon, {
                className: "h-4 w-4 opacity-50"
            })
        ]
    }));
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
const SelectScrollUpButton = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(SelectPrimitive.ScrollUpButton, {
        ref: ref,
        className: cn('flex cursor-default items-center justify-center py-1', className),
        ...props,
        children: /*#__PURE__*/ _jsx(ChevronUpIcon, {})
    }));
SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
const SelectScrollDownButton = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(SelectPrimitive.ScrollDownButton, {
        ref: ref,
        className: cn('flex cursor-default items-center justify-center py-1', className),
        ...props,
        children: /*#__PURE__*/ _jsx(ChevronDownIcon, {})
    }));
SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
const SelectContent = /*#__PURE__*/ React.forwardRef(({ className, children, position = 'popper', ...props }, ref)=>/*#__PURE__*/ _jsx(SelectPrimitive.Portal, {
        children: /*#__PURE__*/ _jsxs(SelectPrimitive.Content, {
            ref: ref,
            className: cn('relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', position === 'popper' && 'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1', className),
            position: position,
            ...props,
            children: [
                /*#__PURE__*/ _jsx(SelectScrollUpButton, {}),
                /*#__PURE__*/ _jsx(SelectPrimitive.Viewport, {
                    className: cn('p-1', position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]'),
                    children: children
                }),
                /*#__PURE__*/ _jsx(SelectScrollDownButton, {}),
                /*#__PURE__*/ _jsx(SelectPrimitive.Arrow, {
                    className: "fill-border"
                })
            ]
        })
    }));
SelectContent.displayName = SelectPrimitive.Content.displayName;
const SelectLabel = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(SelectPrimitive.Label, {
        ref: ref,
        className: cn('px-2 py-1.5 text-sm font-semibold', className),
        ...props
    }));
SelectLabel.displayName = SelectPrimitive.Label.displayName;
const SelectItem = /*#__PURE__*/ React.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ _jsxs(SelectPrimitive.Item, {
        ref: ref,
        className: cn('relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ _jsx(SelectPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ _jsx(CheckIcon, {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SelectPrimitive.ItemText, {
                children: children
            })
        ]
    }));
SelectItem.displayName = SelectPrimitive.Item.displayName;
const SelectSeparator = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(SelectPrimitive.Separator, {
        ref: ref,
        className: cn('-mx-1 my-1 h-px bg-muted', className),
        ...props
    }));
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;
export { Select, SelectGroup, SelectValue, SelectTrigger, SelectContent, SelectLabel, SelectItem, SelectSeparator, SelectScrollUpButton, SelectScrollDownButton };
